export function sleep(ms: number, cancel?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(resolve, ms);
    cancel?.addEventListener('abort', () => {
      clearTimeout(timeout);
      reject(new Error('timer cancelled'));
    });
  });
}
